module.exports = __webpack_public_path__ + "media/images/village/main-event-2022/icons-ce09d168985f1f96b3ad938ec892120f.svg";